import { DynamicFormConstants } from "../types/DynamicFormConstants";

export const DynamicFormActions = {
  dynamicFormError,
  dynamicFormSuccess,
  dynamicFormRequest,
  getALLDynamicFormRequest,
  getALLDynamicFormSuccess,
  getALLDynamicFormError,
  getDynamicFormByIdRequest,
  getDynamicFormByIdSuccess,
  getDynamicFormByIdError,
  getActiveDynamicFormRequest,
  getActiveDynamicFormSuccess,
  getActiveDynamicFormError,
  clear,
};

function dynamicFormRequest(data) {
  return { type: DynamicFormConstants.DYNAMIC_FORM_REQUEST, data };
}
function dynamicFormSuccess() {
  return { type: DynamicFormConstants.DYNAMIC_FORM_SUCCESS };
}
function dynamicFormError() {
  return { type: DynamicFormConstants.DYNAMIC_FORM_FAILIURE };
}
function getALLDynamicFormRequest() {
  return { type: DynamicFormConstants.GET_ALL_DYNAMIC_FORM_REQUEST };
}
function getALLDynamicFormSuccess(data) {
  return { type: DynamicFormConstants.GET_ALL_DYNAMIC_FORM_SUCCESS, data };
}
function getALLDynamicFormError() {
  return { type: DynamicFormConstants.GET_ALL_DYNAMIC_FORM_FAILIURE };
}
function getDynamicFormByIdRequest(id) {
  return { type: DynamicFormConstants.GET_DYNAMIC_FORM_BY_ID_REQUEST, id };
}
function getDynamicFormByIdSuccess(data) {
  return { type: DynamicFormConstants.GET_DYNAMIC_FORM_BY_ID_SUCCESS, data };
}
function getDynamicFormByIdError() {
  return { type: DynamicFormConstants.GET_DYNAMIC_FORM_BY_ID_FAILIURE };
}
function getActiveDynamicFormRequest() {
  return { type: DynamicFormConstants.GET_ACTIVE_DYNAMIC_FORM_REQUEST };
}
function getActiveDynamicFormSuccess(data) {
  return { type: DynamicFormConstants.GET_ACTIVE_DYNAMIC_FORM_SUCCESS, data };
}
function getActiveDynamicFormError() {
  return { type: DynamicFormConstants.GET_ACTIVE_DYNAMIC_FORM_FAILIURE };
}
function clear() {
  return { type: DynamicFormConstants.CLEAR_ALL_DYNAMIC_FORM };
}
